module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Organization created","message":"You can now assign roles on behalf of this organization, see which users belong to the organization etc."},"da":{"title":"Organisation oprettet","message":"Du kan nu oprette lokaladministratorer til organisationen som kan tildele roller til brugere på vegne af denne organisation."}}')
  delete Component.options._Ctor
}
